/**
 * Language & currency popup
 * Utilise le système générique Popup (_popup.js)
 */

import Popup from './_popup';

const COOKIE_NAME = 'douze_cycles_preferences_set';
const COOKIE_DAYS = 365;

function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}

function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
}

document.addEventListener('DOMContentLoaded', () => {
    const popup = document.querySelector('[data-popup="language-currency"]');
    if (!popup) return;

    // Ouvrir automatiquement si le cookie n'est pas défini
    if (!getCookie(COOKIE_NAME)) {
        Popup.open('language-currency');
    }

    // Définir le cookie à la soumission du formulaire
    const form = popup.querySelector('form');
    if (form) {
        form.addEventListener('submit', () => {
            setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
        });
    }

    // Définir le cookie si on ferme le popup sans soumettre
    popup.addEventListener('popup:close', () => {
        setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    });
});
